import React from "react";

import { navigate } from "../../../helpers/utils";

import Preferences from "./Preferences";

export default class SettingsPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  goBack = () => {
    navigate(this.controller, "rn:home_card");
  };

  render() {
    return <Preferences controller={this.controller} goBack={this.goBack} />;
  }
}
